<section class="bank-pay">
  <form>
    <div class="form__group">
      <select
        class="form__control select"
        id="exampleFormControlSelect1"
        [(ngModel)]="sortCode"
        name="sortCode"
        >
        <option disabled value="">Bank Name</option>
        @for (bank of banks; track bank) {
          <option [value]="bank.Code">
            {{ bank.name }}
          </option>
        }
      </select>
    </div>

    <div class="form__group">
      <input
        type="text"
        placeholder="Enter Account Number"
        class="form__control"
        name="accountNumber"
        [(ngModel)]="accountNumber"
        (input)="getAccountDetails($event.target.value)"
        appNumbersOnly
        />
    </div>
    <div class="form__group">
      <input
        type="text"
        placeholder="Account full name"
        class="form__control"
        [(ngModel)]="fullName"
        name="fullName"
        [disabled]="true"
        />
    </div>
    <!-- <div class="form__group">
    <input
      type="password"
      placeholder="Input code"
      class="form__control"
      appNumbersOnly
      />
  </div> -->
  <button
    class="btn btn__primary w-100 no-margin-l btn__md"
    [disabled]="!sortCode || !accountNumber || !fullName"
    (click)="makePayment()"
    >
    Submit
  </button>
</form>
</section>
